<mat-dialog-content aria-label="dialog-box">
  <mat-spinner></mat-spinner>
  <div class="text-center">{{ message }}</div>
</mat-dialog-content>
